export default "__VITE_ASSET__C7laoj5___"